import { ChangeRequestStatusTypes } from "@enums/change-request-status-types";

export const changeRequestStatuses: { [key: string]: string } = {
    [ChangeRequestStatusTypes.UNSUBMITTED]: ChangeRequestStatusTypes.UNSUBMITTED,
    [ChangeRequestStatusTypes.UNDER_REVIEW]: ChangeRequestStatusTypes.UNDER_REVIEW,
    [ChangeRequestStatusTypes.SUBMITTED]: ChangeRequestStatusTypes.SUBMITTED,
    [ChangeRequestStatusTypes.APPROVED]: ChangeRequestStatusTypes.APPROVED,
    [ChangeRequestStatusTypes.REJECTED]: ChangeRequestStatusTypes.REJECTED,
    [ChangeRequestStatusTypes.DEPLOYMENT_SCHEDULED]: ChangeRequestStatusTypes.DEPLOYMENT_SCHEDULED,
    [ChangeRequestStatusTypes.CANCELED]: ChangeRequestStatusTypes.DEPLOYED,
};